import { ApolloProvider } from "@apollo/client"
import { apollo1Client } from "./gqlF/apolloClientF.mts"
import { PtSiteCtx, defaultSiteCtx } from "./CustomSiteF/CustomSiteWrapperF"

export const PtSiteWrap = (/** @type {{children: any, value?: any, client?: any}} */ {children, value=defaultSiteCtx, client=apollo1Client}) => {
  return <ApolloProvider {...{client}}>
    <PtSiteCtx.Provider {...{value}}>
      {children}
    </PtSiteCtx.Provider>
  </ApolloProvider>
}